import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class LoadingService {
    public loader$ = new Subject<boolean>();
    public test:boolean = false
}
